export enum SESSION_STORAGE_KEYS {
    hasUploadedSpouseIncome = 'hasUploadedSpouseIncome',
    hasUploadedApplicantIncome = 'hasUploadedApplicantIncome',


    numberOfUploadedResidencyDocuments = 'numberOfUploadedResidencyDocuments',
}